export const WHATSAPP_NUMBER = "918920893912";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
